<template>
  <adivare-input
    @validation-request="validateField"
    :outer-class="outerClass"
    :input-class="inputClass"
    :autocomplete="autocomplete"
    :legend-class="legendClass"
    form-type="email"
    :show-property="true"
    :label-class="labelClass"
    :property-name="propertyName"
    :placeholder="fieldLabel"
    :field-label="fieldLabel"
    :optional="optional"
    :custom-error-message="errorMessage"
  />
</template>

<script>
import formMixin from "../../../mixins/form-mixin";

export default {
  name: "adivare-email-form-element",
  mixins: [
    formMixin,
  ],
  computed: {
    errorMessage() {
      return false === this.$store.getters.getFormFieldValidityState(this.propertyName)
        ? 'messages_nl.label.cancellation.userLetter.email.error'
        : '';
    },
  },
  methods: {
    validateField(value) {
      this.$store.commit('updateFormFieldValidity', {
        name: this.propertyName,
        valid: this.validateEmail(value)
      });
    },
    validateEmail(email) {
      return /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email);
    }
  },
}
</script>
